/**
 * A metadata pill on the careers board, in the dcv2 design language.
 *
 * The two tones survive as an API because the card marks workplace and
 * seniority differently, but they no longer carry two unrelated hues: the
 * canvas has one accent, so "cyan" reads as the accent and "purple" as plain
 * ink. Both sit on the same 999-radius mono chip.
 */
export function Pill({ children, tone }: { children: React.ReactNode; tone: "cyan" | "purple" }) {
  const tones = {
    cyan: { color: "var(--link)", borderColor: "rgba(var(--ink-rgb),.3)" },
    purple: { color: "rgba(var(--ink-rgb),.66)", borderColor: "rgba(var(--ink-rgb),.3)" },
  } as const;
  return (
    <span
      style={{
        display: "inline-block",
        fontFamily: "'Manrope', sans-serif",
        fontSize: 12,
        lineHeight: 1.2,
        borderRadius: 999,
        padding: "7px 15px",
        border: `1px solid ${tones[tone].borderColor}`,
        color: tones[tone].color,
      }}
    >
      {children}
    </span>
  );
}
